module.exports = __webpack_public_path__ + "static/media/IMG-8.a1098bc2.jpg";